// Lightweight GA4 helpers for GTM dataLayer pushes (search-app).
// Mirrors the pattern used in ecommerce-app/src/utils/ga4.js.

export const pushSearchAutocompleteResultClick = ({ searchTerm, hit }) => {
    if (!hit?.source) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'search_autocomplete_result_click',
        search_term: searchTerm || '',
        content_type: hit.source.contentType || '',
        content_title: hit.source.title || '',
        content_url: hit.source.link || '',
    });
};
